import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { GoogleAuthProvider, getAuth, signInWithPopup } from "firebase/auth";
import LogoIndigo from "../images/indigo_logo.svg";
import LoginImage from "../images/image-login.png";
import Logoalbo from "../images/UI-logo.svg";
import { useSessionClosed } from "./modals/session";
import { Alert, Loader } from "../components";
import * as API from "../http/api";

import { Button, CssBaseline, Grid, Box } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { Lock } from "@mui/icons-material";
import { theme } from "../util/TableStyles";
import { WidgetStyle } from "../util/Styles";

const Login = (props) => {
    const history = useHistory();
    const [loader, setLoader] = useState(false);
    const [alert, setAlert] = useState(false);
    const [dialog, setDialog] = useState(false);
    const [typeAlert, setTypeAlert] = useState("");
    const [contentAlert, setContentAlert] = useState("");

    useEffect(() => {
        setDialog(false);

        //@ts-ignore
        //@ts-nocheck
        if (history.location.state?.hasOwnProperty("logout") && history.location.state.logout) {
            setAlert(true);
            setTypeAlert("success");
            setContentAlert("Has cerrado sesión con exito");
        } else
        //@ts-ignore
        //@ts-nocheck
        if (history.location.state?.hasOwnProperty("sessionClosed") && history.location.state.sessionClosed) {
            handleSession();
        } else {
            session();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { DialogSessionClosed, close: confirmCloseSession } =
        useSessionClosed(
            "Se cerró tu sesión por inactividad",
            "Despues de un tiempo de inactividad, se ha cerrado tu sesión por seguridad. Vuelve a iniciar sesión para acceder a la plataforma."
        );

    const handleSession = async () => {
        setDialog(true);
        if(localStorage.session){
            let response = await API.logout();
            if (response.status === 200) {
                delete localStorage.session;
                delete localStorage.config;
                history.push("/login", { sessionClosed: false });
            }
        }
        const state = await confirmCloseSession();
        state ? setDialog(true) : setDialog(false);
    };

    const redirect = (url) => {
        history.push(url);
    };

    const session = async () => {
        if (localStorage.session) {
            redirect("/");
        }
    };

    const login = async () => {
        setLoader(true);
        let provider = new GoogleAuthProvider();
        let auth = getAuth();
        let user = await signInWithPopup(auth, provider).then(
            (result) => {
                let user = {
                    email: result.user.email,
                    picture: result.user.photoURL,
                    hd: "albo.mx",
                };
                user["uid"] = result.user.uid;
                user["provider"] = result.providerId;
                return user;
            },
            (error) => {
                console.log(error);
                return {};
            }
        );
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        let session = {};
        let request = {};

        if (user.hasOwnProperty("uid")) {
            if (!props.pos.hasOwnProperty("lat") || !props.pos.hasOwnProperty("lon")) {
                console.log("NO HAY GEO");
            }
            request = await API.login(user, props.pos, history);
        } else {
            setLoader(false);
        }

        if (request?.["status"] === 200) {
            localStorage.session = JSON.stringify(request["data"]);
            history.push("/");
        } else if (request?.["status"] === 400) {
            delete localStorage.session;
            setLoader(false);
            changeAlert(true, "error", "El usuario no se ha encontrado en albo.mx");
        } else {
            delete localStorage.session;
            setLoader(false);
        }
    };

    const changeAlert = (flag, type, message) => {
        setTypeAlert(type);
        setAlert(flag);
        setContentAlert(message);
    };

    return (
        <WidgetStyle property={"false"} style={{margin: 0}}>
            <ThemeProvider theme={theme}>
                {!loader && (
                    <Grid container component="main" sx={{height: "100vh","& .MuiInputBase-root": {height: "3.6rem"}}}>
                        <CssBaseline />
                        <Grid item container xs={4} sm={6} md={5} px={"6rem"} py={"3.5rem"} sx={{ height: "100vh" }} flexWrap={"wrap"} display={"flex"} alignContent={"space-between"}>
                            <Grid>
                                <Box component="img" alt="logo" src={LogoIndigo} width={"16rem"}/>
                            </Grid>
                            <Grid item container spacing={"1rem"} sx={{ mt: "14px" }} ml={0}>
                                <Button
                                    onClick={login.bind(this)} variant="contained" size="large" fullWidth
                                    sx={{mt: "2rem", mb: "0.8rem", textTransform: "none", fontWeight: 700, fontSize: "18px", height: "3rem"}}>
                                    Iniciar sesión
                                </Button>
                                <Grid container>
                                    <Grid item xs fontSize={"16px"}>
                                        <Lock sx={{ fontSize: "21px" }} />
                                        <strong>Acceso seguro.</strong> Para
                                        acceder tendrás que completar un proceso
                                        de autenticación vía Google.
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid>
                                <Box component="img" alt="logoalbo" src={Logoalbo} width={"6rem"}/>
                            </Grid>
                        </Grid>
                        <Grid item xs={6} sm={4} md={7} px={"28px"} 
                            sx={{ backgroundColor: "#f2f0f0", textAlign: "-webkit-center" }}
                            >
                            <Box component="img" alt="LoginImage" height={"99vh !important"} src={LoginImage}/>
                        </Grid>
                    </Grid>
                )}
				{
					alert &&
					<Alert
						type={typeAlert}
						content={contentAlert}
						changeAlert={changeAlert}
					/>
				}
                {loader && <Loader />}
                { dialog && <DialogSessionClosed />}
                {/* {!loader && dialog && <DialogSessionClosed />} */}
            </ThemeProvider>
        </WidgetStyle>
    );
};

export default Login;
